<ng-container>
  <div class="mb-7">
    <app-card-verification-form
      (afterActionVerification)="afterActionVerification($event)"
      (cardNoteChanged)="noteChanged($event)"
      [bodyData]="bodyDataScope.value"
      [cardNoteValue]="noteValue(EnumCardVerificationSection.SCOPE)"
      [dataValue]="dataValue"
      [isLoading]="isLoading"
      [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.scope)"
      [isViewOnly]="isViewOnly"
      [sessionKey]="revisionType"
      [status]="dataValue.value.scope?.status_verified_enum ?? ''"
      [title]="'Cakupan'"
      [withBadgeCheck]="ShowBadge"
      [typeSection]="EnumCardVerificationSection.SCOPE"
      [type]="EnumCardVerificationForm.DEFAULT"
    />
  </div>
  <div class="my-7">
    <app-card-verification-form
      (afterActionVerification)="afterActionVerification($event)"
      (cardNoteChanged)="noteChanged($event)"
      [bodyData]="bodyDataDistributor.value"
      [cardNoteValue]="noteValue(EnumCardVerificationSection.DISTRIBUTOR_DETAIL)"
      [dataValue]="dataValue"
      [isLoading]="isLoading"
      [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.distributor_detail)"
      [isViewOnly]="isViewOnly"
      [sessionKey]="revisionType"
      [status]="dataValue.value.distributor_detail?.status_verified_enum"
      [title]="'Detail Distributor'"
      [withBadgeCheck]="ShowBadge"

      [typeSection]="EnumCardVerificationSection.DISTRIBUTOR_DETAIL"
      [type]="EnumCardVerificationForm.DEFAULT"
    />
  </div>
  <ng-container *ngIf="!isOnlyChangeSubArea">
    <div class="my-7">
      <app-card-verification-form
        (afterActionVerification)="afterActionVerification($event)"
        (cardNoteChanged)="noteChanged($event)"
        [bodyData]="bodyDataOwner.value"
        [cardNoteValue]="noteValue(EnumCardVerificationSection.OWNER)"
        [dataValue]="dataValue"
        [isLoading]="isLoading"
        [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.owner)"
        [isViewOnly]="isViewOnly"
        [sessionKey]="revisionType"
        [status]="dataValue.value.owner?.status_verified_enum"
        [withBadgeCheck]="ShowBadge"
        [title]="'Pemilik Usaha'"
        [typeSection]="EnumCardVerificationSection.OWNER"
        [type]="EnumCardVerificationForm.KTP"
      />
    </div>
    <div class="my-7">
      <app-card-verification-form
        (afterActionVerification)="afterActionVerification($event)"
        (cardNoteChanged)="noteChanged($event)"
        [bodyData]="bodyDataManager.value"
        [cardNoteValue]="noteValue(EnumCardVerificationSection.MANAGER)"
        [dataValue]="dataValue"
        [isLoading]="isLoading"
        [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.manager)"
        [isViewOnly]="isViewOnly"
        [withBadgeCheck]="ShowBadge"
        [sessionKey]="revisionType"
        [status]="dataValue.value.manager?.status_verified_enum"
        [title]="'Pengelola Usaha'"
        [typeSection]="EnumCardVerificationSection.MANAGER"
        [type]="EnumCardVerificationForm.KTP"
      />
    </div>
    <ng-container *ngIf="isViewOnly">
      <div class="my-7">
        <app-card-verification-form
          (afterActionVerification)="afterActionVerification($event)"
          (cardNoteChanged)="noteChanged($event)"
          [bodyData]="bodyDataBusiness.value"
          [cardNoteValue]="noteValue(EnumCardVerificationSection.BUSINESS_INFORMATION)"
          [dataValue]="dataValue"
          [isLoading]="isLoading"
          [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValueBusiness.value.business_information)"
          [withBadgeCheck]="ShowBadge"
          [isViewOnly]="isViewOnly"
          [sessionKey]="revisionType"
          [status]="dataValueBusiness.value.business_information?.status_verified_enum"
          [title]="'Informasi Usaha'"
          [typeSection]="EnumCardVerificationSection.BUSINESS_INFORMATION"
          [type]="EnumCardVerificationForm.KTP"
        />
      </div>
      <div class="my-7">
        <app-card-verification-form
          (afterActionVerification)="afterActionVerification($event)"
          (cardNoteChanged)="noteChanged($event)"
          [bodyData]="bodyDataNpwp.value"
          [cardNoteValue]="noteValue(EnumCardVerificationSection.NPWP_INFORMATION)"
          [dataValue]="dataValue"
          [withBadgeCheck]="ShowBadge"
          [isLoading]="isLoading"
          [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.npwp_information)"
          [isViewOnly]="isViewOnly"
          [sessionKey]="revisionType"
          [status]="dataValue.value.npwp_information?.status_verified_enum"
          [title]="'Informasi NPWP'"
          [typeSection]="EnumCardVerificationSection.NPWP_INFORMATION"
          [type]="EnumCardVerificationForm.DEFAULT"
        />
      </div>
    </ng-container>
    <div *ngIf="!!bodyDataBranch.value.length" class="my-7">
      <app-card-verification-form
        (afterActionVerification)="afterActionVerification($event)"
        (cardNoteChanged)="noteChanged($event)"
        [bodyDataBranch]="bodyDataBranch.value"
        [cardNoteValue]="noteValue(EnumCardVerificationSection.BUSINESS_BRANCH)"
        [dataValue]="dataValue"
        [withBadgeCheck]="ShowBadge"
        [isLoading]="isLoading"
        [isNotHaveRevision]="detailRegistrationService.checkNotHaveRevision(dataValue.value.business_branch)"
        [isViewOnly]="isViewOnly"
        [sessionKey]="revisionType"
        [status]="dataValue.value.business_branch?.status_verified_enum"
        [title]="'Cabang Usaha'"
        [typeSection]="EnumCardVerificationSection.BUSINESS_BRANCH"
        [type]="EnumCardVerificationForm.GROUP"
      />
    </div>
  </ng-container>
</ng-container>

<ng-template #loadingTpl>
  <ng-container *ngFor="let item of Array.from(Array(10).keys())">
    <app-card [cardClasses]="'mb-7'">
      <ng-container cardBody>
        <app-skeleton-text [height]="15" [width]="250"></app-skeleton-text>
        <div class="my-7">
          <app-skeleton-text [height]="15" [width]="200"></app-skeleton-text>
          <app-skeleton-text [height]="15" [width]="250"></app-skeleton-text>
          <app-skeleton-text [height]="15" [width]="300"></app-skeleton-text>
        </div>
        <div class="d-flex">
          <div class="me-7">
            <app-skeleton-text [height]="25" [width]="100"></app-skeleton-text>
          </div>
          <div class="mx-7">
            <app-skeleton-text [height]="25" [width]="100"></app-skeleton-text>
          </div>
        </div>
      </ng-container>
    </app-card>
  </ng-container>
</ng-template>
